import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import MTDPerformanceReport from '../../components/ReportForHK/MTDPerformanceReport'
import { HK_REPORT_PATH } from '../../util/reportForHkAccess'

const ReportForHK = (): JSX.Element => (
  <Switch>
    <Route exact path={HK_REPORT_PATH} component={MTDPerformanceReport} />
    <Redirect to={HK_REPORT_PATH} />
  </Switch>
)

export default ReportForHK
